import Cookies from "js-cookie";
import EventsService from "../../../../services/events/eventsService";
import { useEffect, useRef } from "react";

const COOKIE_NAME = 'favoriteEvents';

export const getFavorites = () => {
    const raw = Cookies.get(COOKIE_NAME);
    return raw ? JSON.parse(raw) : [];
};

export const addFavorite = (eventId) => {
    const favorites = getFavorites();
    if (!favorites.includes(eventId)) {
        favorites.push(eventId);
        Cookies.set(COOKIE_NAME, JSON.stringify(favorites), { expires: 30 });
    }
};

export const removeFavorite = (eventId) => {
    const favorites = getFavorites().filter(id => id !== eventId);
    Cookies.set(COOKIE_NAME, JSON.stringify(favorites), { expires: 30 });
};

export const isFavorite = (eventId) => {
    return getFavorites().includes(eventId);
};

export const validateFavorites = async () => {
    const favorites = getFavorites();
    const stillValid = [];
    const stillValidEvents = [];

    for (const id of favorites) {
        if (id) {
            const res = await EventsService.getEvent(id);
            const event = await res?.data?.data;
            const now = new Date();
            const eventEndDate = new Date(event.endDate);

            if (event && eventEndDate > now) {
                stillValid.push(id);
                stillValidEvents.push(event);
            }
        }
    }

    Cookies.set(COOKIE_NAME, JSON.stringify(stillValid), { expires: 30 });
    return stillValidEvents;
};

export const Cookie = {
    get(name) {
        const m = document.cookie.match(
            new RegExp("(^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
        );
        try { return m ? JSON.parse(decodeURIComponent(m[2])) : null; } catch { return null; }
    },
    set(name, val, days = 7) {
        const maxAge = days * 24 * 60 * 60;
        document.cookie = `${name}=${encodeURIComponent(JSON.stringify(val))}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
    },
    remove(name) {
        document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
    },
    removeAll(eventId) {
        this.remove(`checkout:${eventId}:user`);
        this.remove(`checkout:${eventId}:attendees`);
    }
};

export const AutoSave = ({ values, onSave, delay = 250 }) => {
    const first = useRef(true);
    useEffect(() => {
        if (first.current) { first.current = false; return; }
        const id = setTimeout(() => onSave(values), delay);
        return () => clearTimeout(id);
    }, [values, onSave, delay]);
    return null;
};
